import { BasePayloadMapper } from '@ps/utils';

import { CompanyMarginSavePayloadDto } from '../dtos/company-margins.dto';
import { CompanyMarginSave } from '../../state/company-margins/company-margins-state.model';

export class CompanyMarginsPayloadMapper extends BasePayloadMapper<
  CompanyMarginSave,
  CompanyMarginSavePayloadDto
> {
  public override toPayload(
    model: CompanyMarginSave,
  ): CompanyMarginSavePayloadDto {
    return {
      buyer_id: model.buyerId,
      supplier_id: model.supplierId,
      margin: model.margin,
    };
  }
}
